import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import WaitingLottie from 'src/assets/lotties/waiting-lottie.json'
import { ButtonLarge } from 'src/components/ButtonLarge'
import { navigateToInstitute } from 'src/utils'
import Mosaic from '../../assets/images/jaf-institute-waiting-screen-mosaic.png'
import * as S from './styles'
import { useContext, useEffect } from 'react'
import DataContext from 'src/contexts/DataContext'

const DeadLine = () => {
  const { registration } = useContext(DataContext)

  return (
    <S.MainContainer>
      <S.LeftContainer>
        <S.HeaderSection>
          <S.Mosaic src={Mosaic} alt="Mosaico Instituto J&F" />
          <S.Title>Ops!</S.Title>
        </S.HeaderSection>
        <S.Description>
          O período de inscrições para o Processo de Admissão{' '}
          {registration.courseYear} já acabou.
        </S.Description>
      </S.LeftContainer>
      <S.RightContainer>
        <S.LottieSection>
          <S.LottieAnimation
            animationData={WaitingLottie}
            autoplay={true}
            loop={true}
          />
          {/* <ButtonLarge
            variant="contained"
            endIcon={<ChevronRightIcon />}
            onClick={() => navigateToInstitute()}
          >
            IR PARA O SITE
          </ButtonLarge> */}
        </S.LottieSection>
      </S.RightContainer>
    </S.MainContainer>
  )
}

export { DeadLine }
